import { useNavigate, useSearch } from "@tanstack/react-router";
import { Header } from "@/app/layout/Header";
import { Main } from "@/app/layout/Main";
import { useActionPermission } from "@/modules/auth/presentation/model/useActionPermission";
import { Breadcrumb } from "@/shared/ui/Breadcrumb";
import {
  useApproveCatalogCandidateMutation,
  useCatalogCandidatesQuery,
  useRejectCatalogCandidateMutation,
} from "../api/queries";
import { CatalogCandidatesTable } from "../ui/CatalogCandidatesTable";

type CandidatesSearch = {
  limit?: number;
  offset?: number;
};

export function CatalogCandidatesPage() {
  const nav = useNavigate({ from: "/app/catalog/candidates" });
  const search = useSearch({
    from: "/app/catalog/candidates",
  }) as CandidatesSearch;

  const list = useCatalogCandidatesQuery({
    limit: search.limit ?? 20,
    offset: search.offset ?? 0,
  });
  const approveMutation = useApproveCatalogCandidateMutation();
  const rejectMutation = useRejectCatalogCandidateMutation();
  const canManage = useActionPermission(["catalog:update"]);

  const data = list.data?.data ?? [];
  const meta = list.data?.meta ?? { total: 0, limit: 20, offset: 0 };

  return (
    <>
      <Header>
        <Breadcrumb
          items={[
            { label: "ແຜງຄວບຄຸມ", to: "/app/dashboard" },
            { label: "Catalog", to: "/app/catalog" },
            { label: "ຄິວ candidate" },
          ]}
        />
      </Header>

      <Main>
        <div className="mb-6">
          <h1 className="font-bold text-2xl tracking-tight">ຄິວ catalog candidate</h1>
          <p className="mt-1 text-muted-foreground text-sm">
            Master ໃໝ່ທີ່ຮ້ານເສີຍຈາກ POS — ແຍກຈາກຄິວ fitment (master active ແລ້ວແຕ່ຍັງບໍ່ຄົບ fitment)
          </p>
        </div>

        <div className="rounded-xl border bg-card pt-2">
          <CatalogCandidatesTable
            isLoading={list.isLoading}
            data={data}
            offset={meta.offset}
            limit={meta.limit}
            totalCount={meta.total}
            onPaginationChange={(offset, limit) =>
              nav({ search: { ...search, offset, limit } })
            }
            canManage={canManage}
            onApprove={async (catalogProductId) => {
              await approveMutation.mutateAsync(catalogProductId);
              await list.refetch();
            }}
            onReject={async (catalogProductId) => {
              await rejectMutation.mutateAsync(catalogProductId);
              await list.refetch();
            }}
          />
        </div>
      </Main>
    </>
  );
}
